import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
import { hasOrderedApprovalSteps } from 'ui-product-approvals-common';
export const useHasOrderedApprovalSteps = approvalType => {
  const getIsUngated = useGetIsUngated();
  const isUngated = getIsUngated(GATES.ORDERED_APPROVAL_STEPS) || getIsUngated(GATES.AGENT_APPROVER);
  return isUngated && hasOrderedApprovalSteps({
    approvalType
  });
};